import { useMemo } from 'react';

import styles from './styles.module.css';
import {
  createTurbineColumns,
  createT5Columns,
  createTurbineRows,
  createT5Rows,
  createFuelSystemColumns,
  createFuelSystemRows,
  createStarterColumns,
  createStarterRows
} from './utils';
import parentStyles from '../../styles.module.css';
import { StatusIndicatorWithStyles } from '../ControlTab/utils';
import Card from '@/components/Card';
import DataTable from '@/components/DataTable';
import EmptyState from '@/components/EmptyState';
import GridContainer from '@/components/GridContainer';
import {
  getTurbineFuelSystemPath,
  getTurbineInstrumentsPath,
  getTurbineStarterPath
} from '@/solaris-lens-common-lib/src/utils/turbinesPaths';
const turbineColumns = createTurbineColumns();
const t5Columns = createT5Columns();
const fuelSystemColumns = createFuelSystemColumns(StatusIndicatorWithStyles);
const starterColumns = createStarterColumns(StatusIndicatorWithStyles);

export default function TurbineTab({ turbineData }: { turbineData: any }) {
  const initialInstrumentsData = useMemo(() => {
    if (turbineData) {
      return getTurbineInstrumentsPath(turbineData) || {};
    }
    return {};
  }, [turbineData]);

  const initialFuelData = useMemo(() => {
    if (turbineData) {
      return getTurbineFuelSystemPath(turbineData) || {};
    }
    return {};
  }, [turbineData]);

  const initialStarterData = useMemo(() => {
    if (turbineData) {
      return getTurbineStarterPath(turbineData) || [];
    }
    return [];
  }, [turbineData]);

  const turbineRows = useMemo(
    () => createTurbineRows(initialInstrumentsData),
    [initialInstrumentsData]
  );

  const t5Rows = useMemo(
    () => createT5Rows(initialInstrumentsData),
    [initialInstrumentsData]
  );

  const fuelSystemRows = useMemo(
    () => createFuelSystemRows(initialFuelData),
    [initialFuelData]
  );

  const starterRows = useMemo(
    () => createStarterRows(initialStarterData),
    [initialStarterData]
  );

  const hasData =
    turbineRows.length > 0 ||
    t5Rows.length > 0 ||
    fuelSystemRows.length > 0 ||
    starterRows.length > 0;

  if (!hasData) {
    return (
      <EmptyState
        title="No data available"
        subtitle="No data available for this tab."
      />
    );
  }

  return (
    <GridContainer
      gap="30px"
      className={parentStyles.gridContainerLeft}
      align="none"
    >
      <Card title="Instruments">
        <GridContainer columns={1} gap="0px" align="left">
          {turbineRows.length > 0 && (
            <DataTable
              rows={turbineRows}
              columns={turbineColumns}
              title="TURBINE"
              type="detail"
              getRowId={row => row.key}
              noLeftMargin={true}
              alignTextLeft={true}
              className={styles.controlTable}
            />
          )}
          {t5Rows.length > 0 && (
            <DataTable
              rows={t5Rows}
              columns={t5Columns}
              title="T5"
              type="detail"
              getRowId={row => row.key}
              noLeftMargin={true}
              alignTextLeft={true}
              className={styles.controlTable}
            />
          )}
        </GridContainer>
      </Card>
      {fuelSystemRows.length > 0 && (
        <Card title="Fuel System">
          <DataTable
            rows={fuelSystemRows}
            columns={fuelSystemColumns}
            type="detail"
            getRowId={row => row.key}
            noLeftMargin={true}
            alignTextLeft={true}
            className={styles.controlTable}
          />
        </Card>
      )}
      {starterRows.length > 0 && (
        <Card title="Starter">
          <DataTable
            rows={starterRows}
            columns={starterColumns}
            type="detail"
            getRowId={row => row.key}
            noLeftMargin={true}
            alignTextLeft={true}
            className={styles.controlTable}
          />
        </Card>
      )}
    </GridContainer>
  );
}
